const calculateIsMobile = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera
  let patterns = ['android', 'Android', 'ANDROID', 'iPhone', 'iPad', 'iPod']

  for (let i = 0; i < patterns.length; i += 1) {
    if (userAgent.indexOf(patterns[i]) !== -1) {
      return true
    }
  }

  return false
}

let _isMobile = calculateIsMobile()

export const isMobileBrowser = () => {
  return _isMobile
}
